import { apiService } from './api';

const API = '/restaurant/tables';
const RES_API = '/restaurant/reservations';

export const restaurantTableService = {
  getAll: () => apiService.get<any>(API),
  getById: (id: number) => apiService.get<any>(`${API}/${id}`),
  create: (data: any) => apiService.post<any>(API, data),
  update: (id: number, data: any) => apiService.put<any>(`${API}/${id}`, data),
  updatePosition: (id: number, data: { positionX: number; positionY: number }) =>
    apiService.patch<any>(`${API}/${id}/position`, data),
  delete: (id: number) => apiService.delete<any>(`${API}/${id}`),
};

export const tableReservationService = {
  getAll: (params?: { date?: string; tableId?: number; status?: string }) =>
    apiService.get<any>(RES_API, params),
  getById: (id: number) => apiService.get<any>(`${RES_API}/${id}`),
  create: (data: any) => apiService.post<any>(RES_API, data),
  update: (id: number, data: any) => apiService.put<any>(`${RES_API}/${id}`, data),
  updateStatus: (id: number, data: { status: string; linkedOrderId?: number }) =>
    apiService.patch<any>(`${RES_API}/${id}/status`, data),
  delete: (id: number) => apiService.delete<any>(`${RES_API}/${id}`),
};
